<template>
  <div>
    <div class="flex flex-center text-center">
      <div
        v-if="$APP.store.android"
        class="q-pa-lg"
      >
        <a
          :href="$APP.store.android"
          target="_blank"
        >
          <img
            src="~assets/google-play-badge.svg"
            alt="Google Play®"
            style="height: 10vh"
          >
        </a>
        <div>Google Play® et le logo Google Play® sont des marques de Google LLC.</div>
      </div>
      <div
        v-if="$APP.store.apple"
        class="q-pa-lg"
      >
        <a
          :href="$APP.store.apple"
          target="_blank"
        >
          <img
            src="~assets/app-store-badge.svg"
            alt="App Store®"
            style="height: 10vh"
          >
        </a>
        <div>Apple® et le logo App Store® sont des marques de Apple Inc.</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ApplicationsLinksBloc'
}
</script>
